export const TOLGEE_LOCALES = [
  'en',
  'en-TW',
  'zh',
  'ms',
  'zh-Hant-HK',
  'zh-Hant-TW',
] as const

export type TolgeeLocale = (typeof TOLGEE_LOCALES)[number]

export const DEFAULT_LOCALE = 'en'
export const DEFAULT_OMS_LOCALE = 'en_SG'

export const OMS_LOCALES = [
  'en_AD',
  'en_AU',
  'en_AT',
  'en_BE',
  'en_BR',
  'en_CA',
  'en_CY',
  'en_CZ',
  'en_DK',
  'en_EE',
  'en_FI',
  'en_FR',
  'en_DE',
  'en_GR',
  'en_HK',
  'zh_HK',
  'en_HU',
  'en_IN',
  'en_ID',
  'in_ID',
  'en_IE',
  'en_IL',
  'en_IT',
  'en_JP',
  'ja_JP',
  'en_XK',
  'en_LV',
  'en_LB',
  'en_LU',
  'en_MO',
  'zh_MO',
  'en_MY',
  'zh_MY',
  'bm_MY',
  'en_MT',
  'en_MX',
  'en_MC',
  'en_ME',
  'en_NL',
  'en_NZ',
  'en_NO',
  'en_PH',
  'en_PL',
  'en_PT',
  'en_QA',
  'en_RU',
  'en_SM',
  'en_SA',
  'en_SG',
  'zh_SG',
  'en_SK',
  'en_SI',
  'en_ES',
  'en_SE',
  'en_CH',
  'en_TW',
  'zh_TW',
  'en_TH',
  'th_TH',
  'en_GB',
  'en_US',
  'en_VA',
  'en_VN',
  'vi_VN',
  'en_KW',
  'ar_KW',
  'en_AE',
]

export const mapOmsLocaleToTolgeeLocale = (
  omsLocale: string
): TolgeeLocale | null => {
  const [locale, region] = omsLocale.split('_')

  switch (locale) {
    case 'en': {
      return 'en'
    }

    case 'zh': {
      switch (region) {
        case 'HK': {
          return 'zh-Hant-HK'
        }

        case 'TW': {
          return 'zh-Hant-TW'
        }

        default: {
          return 'zh'
        }
      }
    }

    case 'bm': {
      return 'ms'
    }

    default: {
      console.error(`Unknown locale ${omsLocale}`)
      return null
    }
  }
}

export const mapTolgeeLocaleToOmsLocale = (
  tolgeeLocale: TolgeeLocale
): string | null => {
  switch (tolgeeLocale) {
    case 'zh': {
      return 'zh_SG'
    }

    case 'ms': {
      return 'bm_MY'
    }

    case 'zh-Hant-HK': {
      return 'zh_HK'
    }

    case 'zh-Hant-TW': {
      return 'zh_TW'
    }

    default: {
      return 'en_SG'
    }
  }
}

export const getOmsLocaleLabel = (omsLocale: string): string => {
  const [locale, region] = omsLocale.split('_')

  switch (locale) {
    case 'en': {
      return 'English'
    }

    case 'zh': {
      switch (region) {
        case 'HK':
        case 'TW': {
          return '繁體中文'
        }

        default: {
          return '中文'
        }
      }
    }

    case 'bm': {
      return 'Bahasa Melayu'
    }

    default: {
      return 'English'
    }
  }
}
